import angular from 'angular';
import NavbarComponent from './navbar.component';

const navbarModule = angular.module('tinaba.common.navbar', [])

.component('navbar', NavbarComponent);

export default navbarModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/navbar/navbar.js
 **/